module.exports = __webpack_public_path__ + "img/newsImg3.ed03788a.png";